module.exports = __webpack_public_path__ + "img/pride-day-dark-small.2f93b6ff.svg";